import './SingleCard.css'

function SingleCard({ card, handleChoice, flipped, disabled }) {

    const handleClick = () => {
        if (!disabled) {
            handleChoice(card)
        }
    }

    return <div className="card">
        {/* Ternary operator to display if its true  */}
        <div className={flipped ? "flipped" : ""}>
            <img className="front" src={card.src} alt="card front" />
            <img
                className="back"
                src="/img/cover.png"
                onClick={handleClick}
                alt="card front"

            />
        </div>
    </div>
}

export default SingleCard;



